module.exports = __webpack_public_path__ + "img/72.2f68b989.jpg";